import { AgmCoreModule } from '@agm/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatInputModule } from '@angular/material/input';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { JwtInterceptor, JwtModule } from '@auth0/angular-jwt';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from 'angularx-social-login';
import { environment } from 'environments/environment';
import { ChartsModule } from 'ng2-charts';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { NgxLongPress2Module } from 'ngx-long-press2';
import { SimplebarAngularModule } from 'simplebar-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthComponent } from './authentification/auth/auth.component';
import { ConfirmRegisterComponent } from './authentification/confirm-register/confirm-register.component';
import { LoginFormComponent } from './authentification/login/login-form/login-form.component';
import { LoginComponent } from './authentification/login/login.component';
import { RegisterRsComponent } from './authentification/register-rs/register-rs.component';
import { RegisterComponent } from './authentification/register/register.component';
import { WelcomeComponent } from './authentification/welcome/welcome.component';
import { ActuLigueComponent } from './component/actu-ligue/actu-ligue.component';
import { ChoiceLigueComponent } from './component/actu-ligue/choice-ligue/choice-ligue.component';
import { ActuComponent } from './component/actu/actu.component';
import { ItemFluxComponent } from './component/actu/item-flux/item-flux.component';
import { FluxRssComponent } from './component/baseComponent/flux-rss/flux-rss.component';
import { ItemFluxRssComponent } from './component/baseComponent/flux-rss/item-flux-rss/item-flux-rss.component';
import { LabelValeurComponent } from './component/baseComponent/label-valeur/label-valeur.component';
import { SportyskyComponent } from './component/baseComponent/sportysky/sportysky.component';
import { UrlComponent } from './component/baseComponent/url/url.component';
import { VideoCoachingComponent } from './component/baseComponent/youtube/video-coaching/video-coaching.component';
import { YoutubeComponent } from './component/baseComponent/youtube/youtube.component';
import { ClubComponent } from './component/club/club.component';
import { ListClubsComponent } from './component/club/list-clubs/list-clubs.component';
import { ConditionsComponent } from './component/conditions/conditions.component';
import { ConfirmSaveComponent } from './component/confirm-save/confirm-save.component';
import { ErrorComponent } from './component/error/error.component';
import { Error500Component } from './component/error500/error500.component';
import { ForgotPasswordComponent } from './component/forgot-password/forgot-password.component';
import { HomeContentComponent } from './component/home/home-content/home-content.component';
import { HomeComponent } from './component/home/home.component';
import { ImgIconeComponent } from './component/img-icone/img-icone.component';
import { LicenceComponent } from './component/licence/licence.component';
import { LoadingComponent } from './component/loading/loading.component';
import { FavoriteComponent } from './component/meteo/favorite/favorite.component';
import { LikeComponent } from './component/meteo/like/like.component';
import { MapComponent } from './component/meteo/map/map.component';
import { MeteoDetailsComponent } from './component/meteo/meteo-details/meteo-details.component';
import { MeteoComponent } from './component/meteo/meteo.component';
import { DrawerContentComponent } from './component/nav/drawer-content/drawer-content.component';
import { NavComponent } from './component/nav/nav.component';
import { ConfirmResetComponent } from './component/parameters/confirm-reset/confirm-reset.component';
import { IconComponent } from './component/parameters/icon/icon.component';
import { ParameterFluxActusComponent } from './component/parameters/parameter-flux-actus/parameter-flux-actus.component';
import { ParameterMenusComponent } from './component/parameters/parameter-menus/parameter-menus.component';
import { ParametersComponent } from './component/parameters/parameters.component';
import { PrametersHomeComponent } from './component/parameters/prameters-home/prameters-home.component';
import { ConfirmEmailLicenceComponent } from './component/profil/confirm-email-licence/confirm-email-licence.component';
import { ConfirmUnlinkComponent } from './component/profil/confirm-unlink/confirm-unlink.component';
import { ConfirmUpdateUserComponent } from './component/profil/confirm-update-user/confirm-update-user.component';
import { MenuProfilComponent } from './component/profil/menu-profil/menu-profil.component';
import { MyClubComponent } from './component/profil/my-club/my-club.component';
import { MyLicenceComponent } from './component/profil/my-licence/my-licence.component';
import { MySkillsTableComponent } from './component/profil/my-skills/my-skills-table/my-skills-table.component';
import { MySkillsComponent } from './component/profil/my-skills/my-skills.component';
import { ProfilComponent } from './component/profil/profil.component';
import { UnlinkLicenceComponent } from './component/profil/unlink-licence/unlink-licence.component';
import { UnsubscribeComponent } from './component/profil/unsubscribe/unsubscribe.component';
import { UnsubscriptionComponent } from './component/profil/unsubscription/unsubscription.component';
import { UpdatePasswordComponent } from './component/profil/update-password/update-password.component';
import { UpdateProfilComponent } from './component/profil/update-profil/update-profil.component';
import { ChoiceTrophyComponent } from './component/profil/wall-of-trophy/choice-trophy/choice-trophy.component';
import { OpendialogUpdateBackgroundComponent } from './component/profil/wall-of-trophy/opendialog-update-background/opendialog-update-background.component';
import { OpendialogViewImgComponent } from './component/profil/wall-of-trophy/opendialog-view-img/opendialog-view-img.component';
import { WallOfTrophyComponent } from './component/profil/wall-of-trophy/wall-of-trophy.component';
import { RegatesComponent } from './component/regates/regates.component';
import { ReglesComponent } from './component/regles/regles.component';
import { ResetPasswordSendComponent } from './component/reset-password-send/reset-password-send.component';
import { ResetPasswordComponent } from './component/reset-password/reset-password.component';
import { AskLicenceComponent } from './component/search-user-licence/ask-licence/ask-licence.component';
import { CheckLicenceComponent } from './component/search-user-licence/check-licence/check-licence.component';
import { ChoicePersonaComponent } from './component/search-user-licence/choice-persona/choice-persona.component';
import { LabelPersonaComponent } from './component/search-user-licence/choice-persona/label-persona/label-persona.component';
import { SearchUserLicenceComponent } from './component/search-user-licence/search-user-licence.component';
import { SkeletonFluxComponent } from './component/skeleton/skeleton-flux/skeleton-flux.component';
import { SkeletonMenuHomeComponent } from './component/skeleton/skeleton-menu-home/skeleton-menu-home.component';
import { SkeletonProfileComponent } from './component/skeleton/skeleton-profile/skeleton-profile.component';
import { SkeletonRegatesComponent } from './component/skeleton/skeleton-regates/skeleton-regates.component';
import { SkeletonSkillsComponent } from './component/skeleton/skeleton-skills/skeleton-skills.component';
import { ScrollToTopDirective } from './shared/directive/scroll-to-top.directive';
import { ErrorInterceptor } from './shared/helpers/error.interceptor';
import { SharedModule } from './shared/shared.module';
import { LoginFfvComponent } from './authentification/login/login-ffv/login-ffv.component';
import { OpendialogCreateUserFfvLicenceComponent } from './authentification/login/opendialog-create-user-ffv-licence/opendialog-create-user-ffv-licence.component';

export function tokenGetter(): string {
  return localStorage.getItem(environment.tokenKey);
}

registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NavComponent,
    ParametersComponent,
    ProfilComponent,
    ErrorComponent,
    DrawerContentComponent,
    HomeContentComponent,
    LoadingComponent,
    ActuComponent,
    MeteoComponent,
    RegatesComponent,
    ClubComponent,
    ReglesComponent,
    LicenceComponent,
    IconComponent,
    LikeComponent,
    FavoriteComponent,
    VideoCoachingComponent,
    ScrollToTopDirective,
    ForgotPasswordComponent,
    AuthComponent,
    LoginComponent,
    RegisterComponent,
    UnsubscriptionComponent,
    ConfirmRegisterComponent,
    WelcomeComponent,
    ResetPasswordSendComponent,
    ResetPasswordComponent,
    MenuProfilComponent,
    UpdateProfilComponent,
    UpdatePasswordComponent,
    ConfirmUpdateUserComponent,
    ItemFluxComponent,
    UnsubscribeComponent,
    MapComponent,
    Error500Component,
    ImgIconeComponent,
    FluxRssComponent,
    UrlComponent,
    LabelValeurComponent,
    SportyskyComponent,
    ItemFluxRssComponent,
    ConditionsComponent,
    MeteoDetailsComponent,
    SearchUserLicenceComponent,
    CheckLicenceComponent,
    AskLicenceComponent,
    MyClubComponent,
    LabelPersonaComponent,
    ChoicePersonaComponent,
    UnlinkLicenceComponent,
    ConfirmUnlinkComponent,
    ConfirmEmailLicenceComponent,
    RegisterRsComponent,
    YoutubeComponent,
    ParameterMenusComponent,
    ParameterFluxActusComponent,
    ListClubsComponent,
    PrametersHomeComponent,
    ActuLigueComponent,
    ChoiceLigueComponent,
    ConfirmResetComponent,
    LoginFormComponent,
    WallOfTrophyComponent,
    ChoiceTrophyComponent,
    MyLicenceComponent,
    SkeletonMenuHomeComponent,
    SkeletonProfileComponent,
    SkeletonFluxComponent,
    SkeletonRegatesComponent,
    MySkillsComponent,
    SkeletonSkillsComponent,
    MySkillsTableComponent,
    OpendialogViewImgComponent,
    OpendialogUpdateBackgroundComponent,
    ConfirmSaveComponent,
    LoginFfvComponent,
    OpendialogCreateUserFfvLicenceComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    RouterModule,
    NgbModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    SimplebarAngularModule,
    SocialLoginModule,
    ChartsModule,
    GoogleMapsModule,
    GooglePlaceModule,
    NgxLongPress2Module,
    AgmCoreModule.forRoot({ apiKey: 'AIzaSyAQqVtmPVmzSNP2ZxFFCNKSnuGRRiB0wi0', libraries: ['places'] }),
    ScrollingModule,
    JwtModule.forRoot({
      config: {
        tokenGetter,
        allowedDomains: [environment.apiDomain],
        disallowedRoutes: [environment.identityApiUrl + 'connect/token', environment.socialBlackListedUrl]
      }
    }),
    // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    JwtInterceptor,
    LoginComponent,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.idGoogle)
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(environment.idFacebook),
          },
        ],
      } as SocialAuthServiceConfig
    },
    { provide: LOCALE_ID, useValue: 'fr' }

  ],
  bootstrap: [AppComponent],
  entryComponents: [
    RegisterRsComponent,
    ChoiceLigueComponent,
    ConfirmResetComponent,
    UnsubscriptionComponent,
    UnlinkLicenceComponent,
    ChoiceTrophyComponent,
    OpendialogViewImgComponent,
    OpendialogUpdateBackgroundComponent,
    ConfirmSaveComponent,
    OpendialogCreateUserFfvLicenceComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {

}
